import React from 'react'
import PropTypes from 'prop-types'
import {
  Text,
  Button,
  Title,
  Spacer,
} from 'components/atoms'
import { ModalConfirm } from 'components/molecules'
import { toast } from 'react-toastify';
import { Toast } from 'containers';
import { useToggle } from 'hooks'
import { useMutation } from 'react-query'
import { deletePage } from 'services/requests'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { deleteDraft } from 'redux/draftsSlice'
import { useEditorContext, actions } from 'context/EditorContext';

const PageDangerZone = ({
  subweb,
  pageId,
}) => {
  const [isOpenConfirmation, toggle] = useToggle(false)
  const dispatchRedux = useDispatch()
  const history = useHistory()
  const [, dispatch] = useEditorContext();

  const [handleDeletePage, { isLoading }] = useMutation(deletePage, {
    onSuccess: () => {
      dispatchRedux(deleteDraft(pageId))
      dispatch({ type: actions.PAGE_DELETE })
      toast.success(
        <Toast
          type="success"
          title="Página apagada."
        />
      );
      history.push(`/${subweb}`)
    },
    onError: (err) => {
      toast.error(
        <Toast
          type="error"
          title="Erro a apagar a página."
          description={err.message}
        />
      );
    }
  })

  const handleConfirm = (hasConfirmed) => {
    if (hasConfirmed) {
      handleDeletePage({
        subweb,
        pageId
      })
    }
    toggle()
  }

  return (
    <div>
      <ModalConfirm
        isOpen={isOpenConfirmation}
        toggle={toggle}
        onChange={handleConfirm}
        title="Apagar página"
        message="Depois de apagada, a página deixará de estar disponível em todos os idiomas e não será possível recuperar a informação. Tem a certeza que pretende continuar?"
        textConfirm="Sim"
        textDiscard="Cancelar"
      />
      <Title as="h3">Apagar página</Title>
      <Text modifiers={['xs']}>Depois de apagada, não será possível recuperar a página.</Text>
      <Spacer top="xs" />
      <Button
        onClick={toggle}
        loading={isLoading}
        modifiers={['danger', 'small', 'smaller']}
      >
        Apagar esta página
      </Button>
    </div>
  )
}

PageDangerZone.propTypes = {
  subweb: PropTypes.string.isRequired,
  pageId: PropTypes.string.isRequired,
}

export default PageDangerZone
